import './MenuComponent.scss';
import { Tab, Tabs } from './Tabs/Tabs';

export default function MenuComponent() {
    var menuDetails = [
        {
            "name": "Breakfast Bowl",
            "price": "$16",
            "category": "mains",
            "description": "Homemade granola, berry compote, yoghurt, seasonal fruits"
        },
        {
            "name": "Eggs Your Way (V) (GF available)",
            "price": "$13",
            "category": "mains",
            "description": "Free range eggs cooked to your liking with a choice of sourdough/multigrain"
        },
        {
            "name": "Eggs Ronnie – $24 (GF option-Hashbrown)",
            "category": "mains",
            "description": "Kakariki signature roti bun served with bacon, poached eggs, hollandaise and rocket",
            "list": {
                "text":"Optional instead of bacon:",
                "options": ["Smoked salmon – $26", "Spinach & mushroom – $24"]
            }
        },
        {
            "name": "Spanish Eggs with Roti Bun – $20",
            "category": "mains",
            "description": "Spicy tomato sauce, chilli baked beans, capsicum, cumin and eggs",
            "subDesc": "Add Chorizo – $4"
        },
        {
            "name": "Smashed Avocado",
            "price": "$18",
            "category": "mains",
            "description": "Harissa butter, smashed avocado, caramelized onion, tomato salsa"
        },
        {
            "name": "Fish and Chips",
            "price": "$22",
            "category": "mains",
            "description": "Tempura battered fish fillet with coleslaw and chips"
        },
        {
            "name": "CheeseBurger with Manuka BBQ Sauce & Fries – $22",
            "category": "mains",
            "description": "Tomato, lettuce, pickles, aioli, swiss cheese, caramelized onions",
            "list": {
                "text": "Vegetarian option:",
                "options": ["Impossible patty +$4", "Vegan cheese +$2"]
            }
        },
        {
            "name": "PB & French Toast w/ Seasoned Fruits",
            "price": "$22",
            "category": "mains",
            "description": "Berry compote, crunchy peanut butter, seasonal fruits, maple syrup, peanuts, whipped cream"
        },
        {
            "name": "Fries with Aioli & Ketchup",
            "price": "$12",
            "category": "mains"
        },
        {
            "name": "Homemade Kimchi and Swiss Cheese Toastie",
            "price": "$17",
            "category": "grilled toasties",
            "description": "Served with potato chips"
        },
        {
            "name": "Ham, Cheese Toastie",
            "price": "$17",
            "category": "grilled toasties",
            "description": "Layers of ham, cheese + your choice of tomato or pineapple w/ potato chips"
        },
        {
            "name": "Garlic Mushrooms, Wilted Greens + Brie Toastie",
            "price": "$17",
            "category": "grilled toasties",
            "description": "Sauteed mushrooms + garlic w/ a combination of spinach, silverbeet + rocket topped with brie w/ potato chips"
        },
        {
            "name": "Bacon + Jalapeno poppers Toastie",
            "price": "$17",
            "category": "grilled toasties",
            "description": "Crispy bacon, three kinds of cheese and spicy pickled jalapenos served with potato chips"
        },
        {
            "name": "Crispy Tofu",
            "price": "$6",
            "category": "Add-Ons"
        },
        {
            "name": "Smoked Salmon",
            "price": "$7",
            "category": "Add-Ons"
        },
        {
            "name": "Bacon",
            "price": "$6",
            "category": "Add-Ons"
        },
        {
            "name": "Ham",
            "price": "$4",
            "category": "Add-Ons"
        },
        {
            "name": "Hollandaise",
            "price": "$3",
            "category": "Add-Ons"
        },
        {
            "name": "Haloumi",
            "price": "$5",
            "category": "Add-Ons"
        },
        {
            "name": "Tomato",
            "price": "$5",
            "category": "Add-Ons"
        },
        {
            "name": "Chorizo",
            "price": "$5",
            "category": "Add-Ons"
        },
        {
            "name": "Chilli beans",
            "price": "$4",
            "category": "Add-Ons"
        },
        {
            "name": "Mushroom",
            "price": "$4",
            "category": "Add-Ons"
        },
        {
            "name": "Avocado",
            "price": "$4",
            "category": "Add-Ons"
        },
        {
            "name": "Egg",
            "price": "$4",
            "category": "Add-Ons"
        },
        {
            "name": "Hash Brown",
            "price": "$4",
            "category": "Add-Ons"
        },
        {
            "name": "Gluten-free bread",
            "price": "$4",
            "category": "Add-Ons"
        },
        {
            "name": "Extra toast",
            "price": "$4",
            "category": "Add-Ons"
        }
    ];
    const res = Object.groupBy(menuDetails, e => e.category);
    console.log(res);
    var menuArray = [];
    return (
        <section id='menu' className='tw-px-4 md:tw-px-16 menu-component'>
            <h3 className='tw-flex tw-justify-center tw-uppercase section-header'>
                Explore the cuisine
            </h3>
            <Tabs>
                {Object.keys(res).map((innerAttr, index) => {
                    return (
                        <Tab key={index} component={res[innerAttr]}>{innerAttr}</Tab>
                    )
                })}
            </Tabs>
        </section>
    );
}
